(function () {
  if (window.jciWagglePriceValueLoaded) return;
  window.jciWagglePriceValueLoaded = true;

  var scriptId = 'jci-sirv-v3-script';
  var scriptUrl = 'https://scripts.sirv.com/sirvjs/v3/sirv.js?modules=spin';

  function loadSirv() {
    if (window.Sirv) return Promise.resolve(window.Sirv);
    if (window.jciSirvPromise) return window.jciSirvPromise;

    window.jciSirvPromise = new Promise(function (resolve, reject) {
      var existingScript = document.getElementById(scriptId) || document.querySelector('script[src*="scripts.sirv.com/sirvjs/v3/sirv.js"]');

      function resolveWhenReady() {
        if (window.Sirv) resolve(window.Sirv);
        else reject(new Error('Sirv loaded without exposing its API.'));
      }

      if (existingScript) {
        if (window.Sirv) resolve(window.Sirv);
        else {
          existingScript.addEventListener('load', resolveWhenReady, { once: true });
          existingScript.addEventListener('error', reject, { once: true });
        }
        return;
      }

      var script = document.createElement('script');
      script.id = scriptId;
      script.src = scriptUrl;
      script.async = true;
      script.onload = resolveWhenReady;
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return window.jciSirvPromise;
  }

  function initializeSpins(scope) {
    var root = scope || document;
    var spins = root.querySelectorAll('[data-jci-sirv-spin]');
    if (!spins.length) return;

    loadSirv().then(function (Sirv) {
      spins.forEach(function (spin) {
        if (spin.dataset.jciSirvReady === 'true') return;
        Sirv.start(spin);
        spin.dataset.jciSirvReady = 'true';
      });
    }).catch(function () {
      spins.forEach(function (spin) {
        spin.classList.add('jci-waggle-price-value__spin--error');
      });
    });
  }

  function stopSpins(scope) {
    if (!window.Sirv || !scope) return;
    scope.querySelectorAll('[data-jci-sirv-spin]').forEach(function (spin) {
      window.Sirv.stop(spin);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeSpins(document);
    }, { once: true });
  } else {
    initializeSpins(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeSpins(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    stopSpins(event.target);
  });
})();
